/**
 * Main imports.
 */
import Vue from 'vue';
import axios from 'axios';

/**
 * Helper functions.
 */
import {
    getBaseUrl,
    isMobile,
    loadDynamicScript,
    showAlert
} from './app-helpers';

/**
 * Vue prototype.
 */
Vue.prototype.$http = axios;

/**
 * Window assignation.
 */
window.Vue = Vue;

window.eventBus = new Vue();

window.axios = axios;

window.jQuery = window.$ = require('jquery');

window.BootstrapSass = require('bootstrap-sass');

window.getBaseUrl = getBaseUrl;

window.isMobile = isMobile;

window.loadDynamicScript = loadDynamicScript;

window.showAlert = showAlert;




// WEBPACK FOOTER //
// ./src/Resources/assets/js/app-core.js